import Dispatch from "./Dispatch";
import NewBooking from "./NewBooking";
import PendingBooking from "./PendingBooking";
import Report from "./Report";

export default { NewBooking, PendingBooking, Report, Dispatch };
